"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _clsx = _interopRequireDefault(require("clsx"));

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {},
    st0: {
      fill: 'none'
    },
    st1: {
      fill: '#C4C6C8'
    }
  };
}, {
  name: 'ZaIcon'
});

var _ref2 = /*#__PURE__*/_react.default.createElement("path", {
  d: "M-20.7-4h-3l-0.7,1.6h-1l2.7-6h0.8l2.7,6h-1L-20.7-4z M-23.4-4.7h2.4l-1.2-2.8L-23.4-4.7z"
});

var _ref3 = /*#__PURE__*/_react.default.createElement("path", {
  d: "M-16.4-4.7h-2.4v-0.6h2.4V-4.7z"
});

var _ref4 = /*#__PURE__*/_react.default.createElement("path", {
  d: "M-14.7-3.1h4.1v0.7h-5.2v-0.6l3.9-4.8h-3.8v-0.7h5v0.6L-14.7-3.1z"
});

var _ref5 = /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
  d: "M17.8,7.9h-3l-0.7,1.6h-1l2.7-6h0.8l2.7,6h-1L17.8,7.9z M15.1,7.2h2.4l-1.2-2.8L15.1,7.2z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M13.1,7.2h-2.4V6.6h2.4V7.2z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M5.8,8.8h4.1v0.7H4.7V8.9l3.9-4.8H4.7V3.4h5V4L5.8,8.8z"
}));

function ZaIcon(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className"]);
  var classes = useStyles({
    classes: pClasses
  });
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    className: (0, _clsx.default)(classes.root, className)
  }, rest), /*#__PURE__*/_react.default.createElement("path", {
    className: classes.st0,
    d: "M0,0h24v24H0V0z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "-25.5",
    y: "-10",
    className: classes.st0,
    width: "21.5",
    height: "10.8"
  }), _ref2, _ref3, _ref4), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    className: classes.st1,
    d: "M9.2,19.1h-3l-0.7,1.6h-1l2.7-6h0.8l2.7,6h-1L9.2,19.1z M6.5,18.4H9l-1.2-2.8L6.5,18.4z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: classes.st1,
    d: "M13.6,18.4h-2.4v-0.6h2.4V18.4z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: classes.st1,
    d: "M15.3,20h4.1v0.7h-5.2V20l3.9-4.8h-3.8v-0.7h5v0.6L15.3,20z"
  })), _ref5);
}

process.env.NODE_ENV !== "production" ? ZaIcon.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string,
    st0: _propTypes.default.string,
    st1: _propTypes.default.string
  }),
  className: _propTypes.default.string
} : void 0;
ZaIcon.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = ZaIcon;
exports.default = _default;